import { useTheme } from "PFApp/theme_context_provider/theme_context_provider_context";
import { Button } from "PFComponents/button";
import ProgressBar from "PFComponents/progress_bar/progress_bar";
import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { FeatureFlag } from "PFTypes";
import { useTranslation } from "react-i18next";

import css from "../../../../parts/overview/detail_view/detail_view.module.scss";
import { Label } from "../parts/label";

type DetailsProps = {
  onBookingsClick?: VoidFunction;
  bookingsTotal: number;
  utilization: number | undefined;
};

export const Details = ({ onBookingsClick, bookingsTotal, utilization }: DetailsProps) => {
  const { t } = useTranslation("bookingModule");
  const showUtilizationMetrics = useIsFeatureEnabled(FeatureFlag.ShowUtilization);
  const { themeVars } = useTheme();

  return (
    <span className={css.details}>
      <span className={css.item}>
        <Label icon="list" text={t("details.bookings")} />
        <div>
          <Button
            kind="blank"
            onClick={onBookingsClick}
            disabled={!onBookingsClick}
            text={`${bookingsTotal}`}
          />
        </div>
      </span>
      {showUtilizationMetrics && (
        <span className={css.item}>
          <Label text={t("details.profile.utilization", { utilization })} />
          <ProgressBar
            className={css.progressBar}
            values={[{ value: utilization ?? 0, color: themeVars["paletteEcharts1"] }]}
            totalValue={100}
          />
        </span>
      )}
    </span>
  );
};
